export default "__VITE_ASSET__420c64c0__"